<div
  class="flex align-middle items-center justify-between p-2 border-b sticky top-0 bg-white z-10"
  *ngIf="detailedEntries.length || browserService.isOnMobile()"
>
  <span class="md:hidden" (click)="onHamburgerClick.emit()"
    ><mat-icon>menu</mat-icon></span
  >
  <span class="flex">
    <h1 class="!text-lg align-middle !m-0 flex">
      <span class="hidden md:inline-block">#</span>
      <span *ngIf="tag" class="md:hidden align-middle">
        <tag-node-icon
          [node]="getTag(tag)"
          [tags]="tagsWithSummaryDetails"
        ></tag-node-icon>
      </span>
      <span class="truncate max-w-[160px] md:max-w-full mr-2"
        >{{ tag || "All entries" }}
      </span>
      <span
        class="cursor-pointer !text-gray-400 hover:bg-gray-100 rounded"
        [ngClass]="{
          'line-through text-gray-300 bg-gray-100': !applyPeriodFilter
        }"
        *ngIf="
          tag &&
          getTag(tag) &&
          getTopLevelTag(getTag(tag), tagsWithSummaryDetails)?.isPeriodic
        "
        (click)="applyPeriodFilter = !applyPeriodFilter; filter()"
      >
        <span
          >in {{ periodService.current.year }} /
          {{ periodService.current.month }}</span
        >
      </span>
    </h1>
  </span>
  <span class="md:hidden">
    <mat-icon
      *ngIf="detailedEntries.length"
      (click)="toggleShowTagsOnMobile()"
      class="text-blue-500"
      [ngClass]="{ 'text-gray-300': !showTagsOnMobile }"
      >label</mat-icon
    >
  </span>
  <span class="text-slate-400 hidden md:block">
    <tag-node-summary
      [withCaptions]="true"
      [showForFixed]="!applyPeriodFilter"
      [node]="getTag(tag)"
      [tags]="tagsWithSummaryDetails"
      (plannedAmountClicked)="onOpenPlannerClick.emit($event.id)"
    ></tag-node-summary>

    <!-- Entries -->
    <span class="ml-4 text-slate-500">
      <span
        >Entries:
        <span>{{ filteredDetailedEntries.length | number : "." }}</span></span
      >
    </span>
  </span>
</div>

<div
  *ngIf="filteredDetailedEntries.length > 0 && browserService.isOnMobile()"
  class="w-full"
>
  <div
    *ngFor="let entry of filteredDetailedEntries"
    (click)="openEditEntryBottomSheet(entry)"
    class="flex justify-between bg-[var(--surface-color)] [&:nth-child(odd)]:bg-[var(--primary-color-100)] p-2"
  >
    <!-- Memo and date -->
    <div class="flex flex-col text-ellipsis max-w-[80%]">
      <span class="w-full truncate">
        <span class="text-gray-500">{{ entry.date | date }}</span>
        <span *ngIf="entry.date && entry.memo">: </span>
        <span class="truncate ... text-ellipsis">{{ entry.memo }}</span>
      </span>
      <div class="mt-2 text-sm" [hidden]="!showTagsOnMobile">
        <div
          *ngFor="let tag of entry.tags; trackBy: trackByTagId"
          class="mb-2"
          (click)="navigateToTag(tag, $event)"
        >
          <span
            class="tag {{
              getTagColor(tag, tagsWithSummaryDetails)
            }} truncate text-sm "
            >#{{ tag.fullPath }}</span
          >
        </div>
      </div>
      <!-- <span>{{ entry.tags }}</span> -->
    </div>

    <!-- Amount -->
    <div
      class="text-green-500"
      [ngClass]="{ '!text-red-500': entry.amount < 0 }"
    >
      {{ entry.amount | prefundCurrency }}
    </div>
  </div>
</div>

<!-- Table for desktop -->
<table
  *ngIf="
    !!filteredDetailedEntries &&
    filteredDetailedEntries.length > 0 &&
    !browserService.isOnMobile()
  "
  mat-table
  matSort
  [dataSource]="dataSource!"
  class="mat-elevation-z8 w-full border-separate table-fixed"
>
  <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

  <col width="10px" />
  <col width="10px" />
  <col width="10px" />
  <col width="40px" />

  <!-- Amount Column -->
  <ng-container matColumnDef="amount">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sticky>Amount</th>
    <td mat-cell *matCellDef="let element" class="max-w-[3rem] truncate">
      <span
        class="text-green-500"
        [ngClass]="{ '!text-red-500': element.amount < 0 }"
        >{{ element.amount | prefundCurrency }}</span
      >
    </td>
  </ng-container>

  <!-- Note Column -->
  <ng-container matColumnDef="memo">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Memo</th>
    <td mat-cell *matCellDef="let element" class="max-w-[15rem] truncate">
      <span matTooltip="{{ element.memo }}">{{ element.memo }}</span>
    </td>
  </ng-container>

  <!-- Tags Column -->
  <ng-container matColumnDef="tags">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Tags</th>
    <td mat-cell *matCellDef="let element" class="max-w-[20rem] truncate">
      <tag-list
        [tags]="element.tags"
        [allTags]="tagsWithSummaryDetails"
      ></tag-list>
    </td>
  </ng-container>

  <!-- Date Column -->
  <ng-container matColumnDef="date">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Date</th>
    <td mat-cell *matCellDef="let element">{{ element.date | date }}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <!-- <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr> -->
  <tr
    mat-row
    (dblclick)="edit(row)"
    *matRowDef="let row; columns: displayedColumns"
    [contextMenuTriggerFor]="musicContextMenu"
    [contextMenuTriggerData]="{ music: row }"
  ></tr>
  <mat-menu #musicContextMenu="matMenu">
    <ng-template matMenuContent let-music="music">
      <button mat-menu-item (click)="edit(music)">
        <mat-icon>edit</mat-icon> Edit
      </button>
      <button mat-menu-item (click)="delete(music)">
        <mat-icon>delete</mat-icon> Delete
      </button>
    </ng-template>
  </mat-menu>
</table>

<div
  *ngIf="!filteredDetailedEntries || filteredDetailedEntries.length === 0"
  class="flex justify-center items-center w-full h-full"
>
  <div class="text-slate-400 text-center" *ngIf="!!tag; else noEntriesAtAll">
    There are no entries tagged with <span class="font-italic">#{{ tag }}</span>
  </div>
  <ng-template #noEntriesAtAll>
    <welcome-to-prefund
      (addEntry)="openAddEntryDialog()"
      (openPlanner)="openPlannerDialog()"
    ></welcome-to-prefund>
  </ng-template>
</div>

<button
  class="!fixed bottom-4 right-4"
  mat-fab
  matTooltip="New entry (N)"
  (click)="openAddEntryDialog()"
>
  <mat-icon>add</mat-icon>
</button>
